import { useQueryClient } from "react-query"
import { useParams } from "react-router-dom";

export default function useSectionChange(){

    const {course} = useParams();

    const queryClient = useQueryClient();

    const fn = async section => {

        await queryClient.cancelQueries({ queryKey: course})

        const previous = queryClient.getQueryData(course)

        queryClient.setQueryData(course, old => {

        let copy = JSON.parse(JSON.stringify(old));

            copy.chapters = copy.chapters.map(c => {
                c.sections = c.sections.map(s => {
                    return s.id === section.id ? section : s;
                })
                return c;
            });

            return copy;
        })

        return { previous }

    }

    return fn;
}